import React, { Component } from 'react';
import { IAppState, IAction } from '../../../../models/action/core';
import { IUserCalendarProps } from '../../../../models/components/user-calendar';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import Moment from 'moment';
import { SecurityContextType } from '../../../../core/SecurityContext';
import * as Actions from '../../../../store/actions/userHome';
import { UserType } from '../../../../models/pages/login.d';
import Translator from '../../../../core/i18n';
import Loading from '../../../loading/loading';
import { Log } from 'ng2-logger';
import { ActivityType, ActivityTypeEnums } from '../../../../models/enums/ActivityType';
import * as types from '../../../../models/action/userHome';
import { withRouter } from 'react-router-dom';
import { IDashboardActivitiesProps } from '../../../../models/components/dashboard-activities';
import { Guid } from 'guid-typescript';
import { Common } from '../../../../core/common';

const _logger = Log.create('content.tsx');

const T = Translator.create();
let _common: Common;

export default class DashboardActivitiesItems extends Component<IDashboardActivitiesProps> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }
    public returnForTeacherActivityStatus = (activityType: string | null, activityComplatedCount: number, activityId: string | null) => {
        if (activityId) {
            return (
                <div className="completion-info">
                    <i className="material-icons">error_outline</i>
                    {activityType === 'Assignment'
                        ? activityComplatedCount > 0
                            ? ' ' + activityComplatedCount.toString() + ' ' + T.t('r_my_user_teacher_calendar_assignment_message')
                            : T.t('r_my_user_teacher_calendar_assignment_message_not_record')
                        : ''}
                    {activityType === 'Video'
                        ? activityComplatedCount > 0
                            ? ' ' + T.t('r_my_user_teacher_calendar_video_message') + ' ' + activityComplatedCount.toString()
                            : T.t('r_my_user_teacher_calendar_video_message_none_record')
                        : ''}
                    {activityType === 'Elesson'
                        ? activityComplatedCount > 0
                            ? ' ' + T.t('r_my_user_teacher_calendar_elesson_message') + ' ' + activityComplatedCount.toString()
                            : T.t('r_my_user_teacher_calendar_elesson_message_none_record')
                        : ''}
                    {activityType === 'Exam'
                        ? activityComplatedCount > 0
                            ? ' ' + T.t('r_my_user_teacher_calendar_exam_message') + ' ' + activityComplatedCount.toString()
                            : T.t('r_my_user_teacher_calendar_exam_message_none_record')
                        : ''}
                    {activityType === 'Forum'
                        ? activityComplatedCount > 0
                            ? ' ' + T.t('r_my_user_teacher_calendar_forum_message') + ' ' + activityComplatedCount.toString()
                            : T.t('r_my_user_teacher_calendar_forum_message_none_record')
                        : ''}
                    {activityType === 'Document'
                        ? activityComplatedCount > 0
                            ? ' ' + T.t('r_my_user_teacher_calendar_document_message') + ' ' + activityComplatedCount.toString()
                            : T.t('r_my_user_teacher_calendar_document_message_none_record')
                        : ''}
                    {activityType === 'Survey'
                        ? activityComplatedCount > 0
                            ? ' ' + T.t('r_my_user_teacher_calendar_survey_message') + ' ' + activityComplatedCount.toString()
                            : T.t('r_my_user_teacher_calendar_survey_message_none_record')
                        : ''}
                    {activityType === 'VirtualClass'
                        ? activityComplatedCount > 0
                            ? ' ' + T.t('r_my_user_teacher_calendar_virtualClass_message') + ' ' + activityComplatedCount.toString()
                            : T.t('r_my_user_teacher_calendar_virtualClass_message_none_record')
                        : ''}
                    {activityType === 'LinkActivity'
                        ? activityComplatedCount > 0
                            ? ' ' + T.t('r_my_user_teacher_calendar_linkActivity_message') + ' ' + activityComplatedCount.toString()
                            : T.t('r_my_user_teacher_calendar_linkActivity_message_none_record')
                        : ''}
                    {activityType === 'Dictionary'
                        ? activityComplatedCount > 0
                            ? ' ' + T.t('r_my_user_teacher_calendar_dictionary_message') + ' ' + activityComplatedCount.toString()
                            : T.t('r_my_user_teacher_calendar_dictionary_message_none_record')
                        : ''}
                    {activityType === 'GenericActivity'
                        ? activityComplatedCount > 0
                            ? ' ' + T.t('r_my_user_teacher_calendar_genericActivity_message') + ' ' + activityComplatedCount.toString()
                            : T.t('r_my_user_teacher_calendar_genericActivity_message_none_record')
                        : ''}
                </div>
            );
        } else {
            return (
                <button>
                    <i className="material-icons">add</i>
                    {T.t('r_user_home_calendar_teacher_add_activity')}
                </button>
            );
        }
    };

    public navigateUrl(classId?: string | null, activityId?: string | null, courseId?: string | null, weekOrUnitId?: string | null) {
        const url =
            '/u/course?classId=' +
            classId +
            '&activityId=' +
            courseId +
            '&type=1' +
            '&actid=' +
            activityId +
            (weekOrUnitId ? '&weekorunitid=' + weekOrUnitId : '');
        this.props.history.push(window.appSettings.DEFAULT_URL + url);
    }

    render() {
        return (<ul style={{marginBottom: 30}} className="course-timeline-item list-unstyled">
            {this.props.activityList && this.props.activityList[0] && this.props.activityList.map((data, i) => {
                return (<li key={'dashboardItem-' + Guid.create()} className={this.props.isPast ? 'active' : ''}
                    onClick={this.navigateUrl.bind(
                        this,
                        data.classId,
                        data.activityId,
                        data.courseId,
                        data.activityTermWeek ? data.activityTermWeek.split(',')[0] : ''
                    )}
                    style={{ cursor: 'pointer' }}
                >
                    <div className="row">
                        <div className="col-md-12">
                            <span tabIndex={0}>
                                {data.activityType && data.activityType === ActivityType.Assignment && data.dueDate
                                    ? 
                                        Moment(data.dueDate).format(this.props.isPast ? 'Do MMM, YYYY / LT' : 'LT')
                                    : 
                                        Moment(data.startDate ? data.startDate : '').format(this.props.isPast ? 'Do MMM, YYYY / LT' : 'LT') 
                                        + ' - ' +
                                        Moment(data.endDate ? data.endDate : '').format('LT')}
                            </span>
                            <label style={{ lineHeight: 1 }} tabIndex={0}
                             onKeyDown={event => {
                                if (event.key === 'Enter') {
                                    this.navigateUrl(
                                        data.classId,
                                        data.activityId,
                                        data.courseId,
                                        data.activityTermWeek ? data.activityTermWeek.split(',')[0] : ''
                                    )
                                }
                            }}
                            >
                                <b style={{ fontWeight: 700 }}>
                                    {data.activityType
                                        ? T.t('r_activity_type_' + data.activityType)
                                        : ''}
                                </b>{' '}
                                {data.activityId ? '-' : ''}{' '}
                                {data.activityName ? data.activityName : ''}
                            </label>
                            {!data.activityId ? (
                                <p className="text-danger">{T.t('r_user_home_calendar_none_activity')}</p>
                            ) : (
                                    <p tabIndex={0} className={ data.courseName ? ((!_common.isArabic(data.courseName) ? 'left-text': '')): ''}>
                                        {data.courseName
                                        ? data.courseName
                                        : T.t('r_api_gen_course_name_not_specified')}
                                    </p>
                                )}
                        </div>
                    </div>
                    {this.props.userType && this.props.userType === UserType.Teacher?
                    <div className="row" style={{ marginTop: 5 }}>
                        <div className="col-md-12">                            
                            {this.returnForTeacherActivityStatus(
                                data.activityType ? data.activityType : null,
                                data.numberOfAttendees,
                                data.activityId
                            )}       
                        </div>
                    </div>
                    : ''}
                </li>);
            })}
        </ul>);
    }
}
